import { t } from '@hefe/i18n';
import { CarReservation } from '@hefe/models';
import { CarsSlice, ModalsSlice } from '@hefe/store';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface AddEditCarReservationFormProps {
  reservation?: CarReservation;
}

export default function AddEditCarReservationForm(
  props: AddEditCarReservationFormProps
) {
  const { reservation } = props;

  const dispatch = useAppDispatch();
  const modalState = useSelector(ModalsSlice.modalsState);

  const carsSelect = useSelector(CarsSlice.reservableCarsSelectSelector);

  const onSubmit = (values: any, resetForm: any) => {
    const closeModal = ModalsSlice.modalsActions.closeModal;
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;

    const action = reservation
      ? CarsSlice.updateCarReservation
      : CarsSlice.createCarReservation;

    const requestData = {
      ...values,
      date_from: (values.dates[0] as dayjs.Dayjs).format('YYYY-MM-DD HH:mm:ss'),
      date_to: (values.dates[1] as dayjs.Dayjs).format('YYYY-MM-DD HH:mm:ss'),
      ...(reservation ? { id: reservation.id } : {}),
    };

    delete requestData.dates;

    dispatch(setModalLoading(true));
    dispatch(action(requestData))
      .unwrap()
      .then(() => {
        dispatch(closeModal());
        resetForm();
      })
      .catch(() => null)
      .finally(() => dispatch(setModalLoading(false)));
  };

  // TODO - set key to has of reservation
  return (
    <CustomForm
      key={`add-edit-car-reservation-form-${reservation ? reservation : 'new'}`}
      formId={`add-edit-car-reservation-form-${
        reservation ? reservation.id : 'new'
      }`}
      fields={[
        {
          name: 'name',
          label: t('name'),
          type: 'text',
          initalValue: reservation?.name,
          rules: [
            {
              required: true,
              message: t('form_errors.name'),
            },
          ],
        },
        {
          name: 'destination',
          label: t('cars.reservations.fields.destination'),
          type: 'text',
          initalValue: reservation?.destination,
          rules: [
            {
              required: true,
              message: t('form_errors.name'),
            },
          ],
        },
        {
          name: 'car_id',
          label: t('cars.singular'),
          type: 'select',
          initalValue: reservation?.car_id,
          selectOptions: carsSelect,
          rules: [
            {
              required: true,
              message: t('form_errors.select_value'),
            },
          ],
        },
        {
          name: 'dates',
          label: t('from'),
          type: 'datetimerange',
          initalValue: [
            dayjs(reservation?.date_from),
            dayjs(reservation?.date_to),
          ],
          rules: [
            {
              required: true,
              message: t('form_errors.date_range'),
            },
          ],
        },
        {
          name: 'email',
          label: t('email'),
          type: 'email',
          initalValue: reservation?.email,
          rules: [
            {
              type: 'email',
              message: t('form_errors.email'),
            },
          ],
        },
        {
          name: 'phone',
          label: t('phone'),
          type: 'text',
          initalValue: reservation?.phone,
          rules: [],
        },
        {
          name: 'note',
          label: t('note'),
          type: 'text',
          initalValue: reservation?.note,
          rules: [],
        },
      ]}
      loading={modalState.modal.loading}
      onSubmit={onSubmit}
    />
  );
}
